import {
    Box,
    Flex,
    Text,
    IconButton,
    Button,
    Stack,
    Collapse,
    Icon,
    Popover,
    PopoverTrigger,
    PopoverContent,
    useColorModeValue,
    useBreakpointValue,
    useDisclosure,
    useColorMode,
    Image,
  } from '@chakra-ui/react';

  import {
    HamburgerIcon,
    CloseIcon,
    ChevronDownIcon,
    ChevronRightIcon,
    MoonIcon,
    SunIcon,
  } from '@chakra-ui/icons';

  import logoLight from "../portFolioLogo.png"

  import pdf from "../Assert/Kiran_Wankhade_Resume.pdf"

  // import kiranLogo from "../KiranLogo.png"
  import kiranLogo from "../newlogo1.png"

  import {HashLink} from "react-router-hash-link";

  
export default function Navbar() {
    const { isOpen, onToggle } = useDisclosure();
    const { colorMode, toggleColorMode } = useColorMode();
    return (
      <Box position={'fixed'} w={'full'} marginTop={-5} zIndex='1' >
        <Flex
          // bg={useColorModeValue('white', 'gray.800')}
          bg='#333333'
          // background="linear-gradient(48deg, rgba(2,0,36,1) 45%, rgba(7,31,78,1) 94%)"
          color={useColorModeValue('gray.600', 'white')}
          minH={'60px'}
          py={{ base: 2 }}
          px={{ base: 4 }}
          align={'center'}>
          <Flex
            flex={{ base: 1, md: 'auto' }}
            ml={{ base: -2 }}
            display={{ base: 'flex', md: 'none' }}>
            <IconButton
              color={'white'}
              _hover={{
                color:'white'
              }}
              onClick={onToggle}
              icon={
                isOpen ? <CloseIcon w={3} h={3} /> : <HamburgerIcon w={5} h={5} />
              }
              variant={'ghost'}
              aria-label={'Toggle Navigation'}
            />
          </Flex>
          <Flex flex={{ base: 1 }} justify={{ base: 'center', md: 'start' }}>
        
            <Image  align={{base:'center' ,  md: 'start' }} width={'85px'} height={'30px'} src={kiranLogo} /> 
            
            <Flex display={{ base: 'none', md: 'flex' }} justifyContent='center' alignItems={'center'} ml={10}>
              <DesktopNav />
            </Flex>
          </Flex>
  
          <Stack
            flex={{ base: 1, md: 0 }}
            justify={'flex-end'}
            direction={'row'}
            spacing={6}
           
            >
            
            <Button
              color='white'
              textDecoration={'underline'}
              textUnderlineOffset='4px' 
              textDecorationThickness= "2px"
              as={'a'}
              fontSize={'lg'}
              fontWeight={'bold'}
              variant={'link'}
              href={pdf}
              _target='blank'
              width='120px'
              padding={2}
              onClick={()=>{
                let url = "https://drive.google.com/file/d/1EMEVNUthn9N6BL4VRy9gAvVWpap44duz/view?usp=share_link" 
                window.open(url, "_blank");
              }}
              download
              >
              Resume
            </Button>
          </Stack>
        </Flex>
  
        <Collapse in={isOpen} animateOpacity>
          <MobileNav />
        </Collapse>
      </Box>
    );
  }
  
  const DesktopNav = () => {
    // const linkColor = useColorModeValue('gray.600', 'gray.200');
    const linkHoverColor = useColorModeValue('gray.800', 'white');
    const popoverContentBgColor = useColorModeValue('white', 'gray.800');
  
    return (
      <Stack direction={'row'} spacing={6}  >
        {NAV_ITEMS.map((navItem) => (
          <Box key={navItem.label}>
            <Popover trigger={'hover'} placement={'bottom-start'}>
              <PopoverTrigger>
                <HashLink
                  p={2}
                  to={navItem.href}
                  fontSize={'sm'}
                  fontWeight={'bold'}
                  color={'white'}
                  
                  _hover={{
                    textDecoration: 'none',
                    color: 'white',
                  }}>
                    <Text color='white' fontWeight={'bold'}>{navItem.label}</Text>
                </HashLink>
              </PopoverTrigger>
            </Popover>
          </Box>
        ))}
      </Stack>
    );
  };
  
  const MobileNav = () => {
    return (
      <Stack
        bg={useColorModeValue('#333333', 'white')}
        p={4}
        display={{ md: 'none' }}
        >
        {NAV_ITEMS.map((navItem) => (
          <MobileNavItem key={navItem.label} {...navItem} />
        ))}
      </Stack>
    );
  };
  
  const MobileNavItem = ({ label, children, href }) => {
    const { isOpen, onToggle } = useDisclosure();
  
    return (
      <Stack spacing={4} onClick={children && onToggle}>
        <Flex
          py={2}
          as={HashLink}
          to={href ?? '#'}
          justify={'space-between'}
          align={'center'}
          _hover={{
            textDecoration: 'none',
          }}>
          <Text
            fontWeight={600}
            color={useColorModeValue('white', 'white')}>
            {label}
          </Text>
          {children && (
            <Icon
              as={ChevronDownIcon}
              transition={'all .25s ease-in-out'}
              transform={isOpen ? 'rotate(180deg)' : ''}
              w={6}
              h={6}
              color='white'
            />
          )}
        </Flex>
  
        <Collapse in={isOpen} animateOpacity style={{ marginTop: '0!important' }}>
          <Stack
            mt={2}
            pl={4}
            borderLeft={1}
            borderStyle={'solid'}
            borderColor={useColorModeValue('white', 'white')}
            align={'start'}>
            {children &&
              children.map((child) => (
                <HashLink key={child.label} py={2} href={child.href}>
                  {child.label}
                </HashLink>
              ))}
          </Stack>
        </Collapse>
      </Stack>
    );
  };
  

  const NAV_ITEMS = [
    {
      label: '🏠︎ Home',
      href: '#/',
    },
    {
      label: '👩🏻‍💼 About',
      href: '#aboutme',
    },
    {
      label: '🎓 Education',
      href: '#education',
    },
    {
      label: '✨ Experience',
      href: '#experience',
    },
    {
      label: '🗂️ Project',
      href: '#projects',
    },
    {
      label: '🎯 Skill',
      href: '#skills',
    },
    {
      label: '📩 Contact',
      href: '#contact',
    },
  ];